module.exports = __webpack_public_path__ + "f7854203f98075f42f8c9867698aebf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/whole_foods_2023_chart.png
// module id = 1761
// module chunks = 0